import axios from "axios";
export default {
    hasRead(id){
        return axios.put(`/notifications/${id}`,{ isRead: true });
    },
    getNotifications(outlet) {
        if(outlet) return axios.get(`/notifications?source=${outlet}&order[createdAt]=desc&order[id]=desc`);
        else return axios.get(`/notifications?order[createdAt]=desc&order[id]=desc`);
    },
    postNotification(obj) {
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        return axios.post('/notifications',obj)
    },
    deleteNotification(id) {
        return axios.delete(`/notifications/${id}`);
    },
    postChannel(payload) {
        return axios.post('/notifications/channel',payload)
    },
};
